/**
 * La zone d'une commune démarchée sur la carte, et sa couleur.
 *
 *  - La TAILLE de la zone suit la taille de la commune : un cercle autour du
 *    centre, dont le rayon croît avec la racine de la population (la surface
 *    bâtie croît à peu près comme la population). Un village fait ~600 m,
 *    Forcalquier ~1,7 km, Manosque ~3,2 km.
 *  - La COULEUR dit combien de fois on y est passé dans les 12 derniers mois :
 *    vert si on y passe rarement, rouge si on y passe souvent. Un passage
 *    ancien sort du compte au bout d'un an : la commune redevient verte.
 *
 * Fonctions PURES : testées sans carte ni réseau.
 */

/** Rayon de la zone, en mètres. */
export function rayonZoneMetres(population: number | null): number {
  if (population === null || population <= 0) return 800;
  return Math.round(Math.min(4000, Math.max(400, 250 + 20 * Math.sqrt(population))));
}

/** Nombre de passages datés (AAAA-MM-JJ) dans les `jours` qui précèdent `aujourdhui`. */
export function passagesRecents(dates: readonly string[], aujourdhui: string, jours = 365): number {
  const fin = Date.parse(`${aujourdhui}T12:00:00Z`);
  const debut = fin - jours * 86_400_000;
  return dates.filter((d) => {
    const t = Date.parse(`${d}T12:00:00Z`);
    return t > debut && t <= fin;
  }).length;
}

export interface PalierFrequence {
  /** Passages sur 12 mois, à partir de ce nombre. */
  min: number;
  label: string;
  couleur: string;
}

/** Du vert (rarement) au rouge (souvent). */
export const PALIERS_FREQUENCE: readonly PalierFrequence[] = [
  { min: 0, label: '0 ou 1 passage', couleur: '#16a34a' },
  { min: 2, label: '2 passages', couleur: '#84cc16' },
  { min: 3, label: '3 passages', couleur: '#f59e0b' },
  { min: 4, label: '4 passages ou plus', couleur: '#dc2626' },
];

/** La couleur d'une commune selon ses passages des 12 derniers mois. */
export function couleurFrequence(passages12Mois: number): string {
  let couleur = PALIERS_FREQUENCE[0]?.couleur ?? '#16a34a';
  for (const p of PALIERS_FREQUENCE) if (passages12Mois >= p.min) couleur = p.couleur;
  return couleur;
}
